import { FormContent, Paging, Table, usePaging, Wrapper } from '@maxtropy/components';
import { Button, Col, Form, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { selectTenantColumns } from '../utils';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import ShowInput from '@/shared/components/ShowInput';
import { getTemplate } from '../../../api/template';
import { getTemplatePage, TemplateListRes } from '../../../api/tenantAttribute';

const routes = [{ name: 'Iot配置' }, { name: '数采配置' }, { name: '模板分配' }, { name: '租户分配属性模板详情' }];

const formLayout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 18 },
};

const TemplateDetail: React.FC = () => {
  const [form] = Form.useForm();
  const { id } = useParams<{ id: string }>();
  const { search } = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const pagingInfo = usePaging(50);
  const { pageOffset, pageSize, setTotalCount } = pagingInfo;
  const [tenantList, setTenantList] = useState<TemplateListRes[]>([]);

  useEffect(() => {
    if (id) {
      getTemplate(Number(id)).then(res => {
        form.setFieldsValue(res.template);
      });
      setLoading(true);
      getTemplatePage({ templateId: id, page: pageOffset, size: pageSize }).then(res => {
        if (res) {
          setTenantList(res.list);
          setTotalCount(res.total);
          setLoading(false);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, pageOffset, pageSize]);

  return (
    <Wrapper routes={routes} {...formLayout}>
      <FormContent title="模板信息">
        <Form layout="vertical" form={form}>
          <Row>
            <Col span={12}>
              <Form.Item label="模板code" name="serialNumber">
                <ShowInput />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="模板名称" name="name">
                <ShowInput />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </FormContent>
      <FormContent title="分配租户">
        <Table columns={selectTenantColumns} dataSource={tenantList} loading={loading} />
        <Paging pagingInfo={pagingInfo} />
        <Button style={{ marginTop: 20 }} onClick={() => navigate(`/device/info/distribution${search}`)}>
          返回
        </Button>
      </FormContent>
    </Wrapper>
  );
};

export default TemplateDetail;
